import { render } from "./BaseSlider.vue?vue&type=template&id=6e7b2dcd&scoped=true"
import script from "./BaseSlider.vue?vue&type=script&lang=js"
export * from "./BaseSlider.vue?vue&type=script&lang=js"

import "./BaseSlider.vue?vue&type=style&index=0&id=6e7b2dcd&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e7b2dcd"]])

export default __exports__